import { services } from "../data";
import { FaCloud, FaRobot, FaLock, FaChartLine } from "react-icons/fa";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const icons = [FaRobot, FaCloud, FaChartLine, FaLock];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.2 }
  }
};

const itemAnim = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

function Services() {
  return (
    <section className="services" id="services">
      <motion.div 
        className="section-header"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <span className="section-tag">Capabilities</span>
        <h2 className="section-title">Our Services</h2>
      </motion.div>

      <motion.div 
        className="service-grid"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-100px" }}
      >
        {services.map((service, index) => {
          const Icon = icons[index % icons.length];
          return (
            <motion.div className="service-card" key={index} variants={itemAnim}>
              <Link to={`/services/${service.slug}`} className="service-link">
                <div className="icon-wrapper">
                  <Icon className="icon" />
                </div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <span className="learn-more">Learn More →</span>
              </Link>
            </motion.div>
          );
        })}
      </motion.div>
    </section>
  );
}

export default Services;